import { getCurrentBreakpoint } from "@shared/libs/breakpoint.utils";
import { breakpoints, UIBreakpoint } from "@shared/constaints/ui";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

interface ScreenSizes {
  currentWidth: number;
  currentBreakpoint: UIBreakpoint;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isHdDesktop: boolean;
  isFhdDesktop: boolean;
  isQhdDesktop: boolean;
}

const calculateSizes = (): ScreenSizes => {
  const { currentWidth, currentBreakpoint } = getCurrentBreakpoint();

  return {
    currentWidth,
    currentBreakpoint,
    isMobile: currentWidth < breakpoints.md,
    isTablet: currentWidth >= breakpoints.md && currentWidth < breakpoints.lg,
    isDesktop: currentWidth >= breakpoints.lg,
    isHdDesktop: currentWidth >= breakpoints.lg && currentWidth < breakpoints.xl,
    isFhdDesktop: currentWidth >= breakpoints.xl && currentWidth < breakpoints.xxl,
    isQhdDesktop: currentWidth >= breakpoints.xxl,
  };
};

export const useScreenSize = (debounceMs: number = 150) => {
  const [sizes, setSizes] = useState<ScreenSizes>(() => calculateSizes());

  const handleResize = useDebouncedCallback(() => {
    setSizes(calculateSizes());
  }, debounceMs);

  useEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return sizes
}